import { FC } from 'react';
import { EventProps } from 'react-big-calendar';

import { IContentGridCalendarEvent } from '../Content.types';
import { CalendarEvent } from './CalendarEvent';
import { ICalendarEventProps } from './CalendarEvent.types';

export const makeCalendarEvent = (
  props: ICalendarEventProps
): FC<EventProps<IContentGridCalendarEvent>> => {
  const component: FC<EventProps<IContentGridCalendarEvent>> = (innerProps) => {
    return (
      <CalendarEvent
        {...innerProps}
        {...props}
      />
    );
  };

  return component;
};
